import { QuestionHiding } from "./types";

// Interface for managing conditional questions visibility and state resetting
// When a parent question changes, we need to:
// 1. Hide/show child questions based on the parent's answer
// 2. Reset the state of child questions when the parent changes from answerIdToShow to something else
export const questionIdsToHack: QuestionHiding[] = [
  {
    questionGroupQuestionId: 36, // Boluje li dijete od teže bolesti?
    answerIdToShow: 48, // Da
    childQuestionId: 37, // teze bolesti
  },
  {
    questionGroupQuestionId: 37, // Teze bolesti - vrsta
    answerIdToShow: 55,
    childQuestionId: 38,
  },
  {
    questionGroupQuestionId: 39, // Ima li dijete dijagnosticiranu teškoću u razvoju?
    answerIdToShow: 56, // Da
    childQuestionId: 40, // The child question to reset (Vrsta teskoce)
  },
  {
    questionGroupQuestionId: 40, // Vrsta teškoće
    answerIdToShow: 64, // Nesto drugo
  },
];

// Backend issue require me to force some questions to be required, to fix the validations
export const questionsToMakeRequired = [40, 41, 37, 38];
